var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isPaymentIframe)?_c('top'):_vm._e(),_c('router-view'),_c('clinic-not-found'),(!_vm.isPaymentIframe)?_c('bottom'):_vm._e(),(!_vm.isPaymentIframe)?_c('footer-component'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }